// extracted by mini-css-extract-plugin
export default {"buttonsBlock":"buttons-block_buttonsBlock__UuJur"};